import PromptForEmailPage from "./PromptForEmailPage"

export default PromptForEmailPage
